















import { mixins } from 'vue-class-component'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import SearchAccount from '@/mixins/search-queries/search-account'
import SearchContact from '@/mixins/search-queries/search-contact'
import { IQuoteAccountInput } from '@/modules/Quote/interfaces/quote-form'
import { Account } from '@/modules/Account/interfaces/account'
import { Contact } from '@/modules/Contact/interfaces/contact'

@Component({
  components: {
    AppTextSearch,
    AppTextField
  }
})
export default class QuoteFormAccount extends mixins(SearchAccount, SearchContact) {
  @Prop({ type: Object as () => IQuoteAccountInput }) value!: IQuoteAccountInput
  @Prop({ type: Object as () => Account }) readonly account!: Account
  @Prop({ type: Object as () => Contact }) readonly contact!: Contact

  get accountDisable () {
    return !!this.account
  }

  get contactDisable () {
    return !!this.contact
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }

  @Watch('value.account', { deep: true })
  onValueChanged (val: Account) {
    if (!val) {
      return
    }
    this.sendAccountWithSource()
  }

  @Emit('onAccountChanged')
  sendAccountWithSource () {
    const { candidatesAccount, value: { account } } = this
    const res = candidatesAccount.find((acct: Account) => {
      return +acct.id === account.id
    })

    return res
  }
}
